import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';

import { useReportPage } from 'shared/hooks';
import { rankingScale } from 'shared/constants/esg';

const rectangularUseStyles = makeStyles(theme => ({
  container: {
    marginRight: 15,
    transform: useReportPage ? 'scale(0.7)' : 'scale(1)',
  },
  item: {
    position: 'relative',
    padding: '5px 0',
    background: theme.palette.grey[300],
    borderBottom: '1px solid white',

    '&:not(:last-child):after, &:not(:last-child):before': {
      content: '""',
      position: 'absolute',
      bottom: -1,
      width: 3,
      height: 1,
      background: theme.palette.grey[300],
    },
    '&:not(:last-child):before': {
      left: 0,
    },
    '&:not(:last-child):after': {
      right: 0,
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  active: {
    background: theme.palette.primary.main,
    color: theme.palette.custom.white,
  },
  text: {
    fontWeight: 500,
    textAlign: 'center',
  },
}));

const RectangularScale = ({ quarter }) => {
  const rectangularClasses = rectangularUseStyles();

  return (
    <div className={rectangularClasses.container}>
      {Object.values(rankingScale).map((v, i) => (
        <div
          key={v}
          className={clsx(rectangularClasses.item, {
            [rectangularClasses.active]: i === quarter - 1,
          })}
        >
          <Typography variant="body2" className={rectangularClasses.text}>
            {v}
          </Typography>
        </div>
      ))}
    </div>
  );
};

RectangularScale.propTypes = {
  quarter: PropTypes.number.isRequired,
};

export { RectangularScale };
